import React, { Component } from "react";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import {
	Container,
	Card,
	CardHeader,
	Button,
	CardBody,
	Row,
	Col,
	Table,
} from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import {
	getProductStockReportList,
	getProductStockExportList,
} from "../../../store/Reports/actions";
import "../reports.scss";

class ProductStockReportList extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount() {
		this.fetchPage(1);
	}

	componentDidUpdate(prevProps) {
		// Auto-download when all-records export data arrives
		if (
			prevProps.productStockExportLoading === true &&
			this.props.productStockExportLoading === false &&
			this.props.ProductStock_ExportData.length > 0
		) {
			this.doExcelDownload(this.props.ProductStock_ExportData);
		}
	}

	fetchPage(page) {
		this.props.getProductStockReportList({
			location: this.props.params?.location,
			group: this.props.params?.group,
			start_date: this.props.params?.start_date,
			end_date: this.props.params?.end_date,
			brand_name: this.props.params?.brand_name,
			subgroup_name: this.props.params?.subgroup_name,
			page,
			page_size: 20,
		});
	}

	handleExcelExport() {
		this.props.getProductStockExportList({
			location: this.props.params?.location,
			group: this.props.params?.group,
			start_date: this.props.params?.start_date,
			end_date: this.props.params?.end_date,
			brand_name: this.props.params?.brand_name,
			subgroup_name: this.props.params?.subgroup_name,
		});
	}

	doExcelDownload(allProducts) {
		const locationName = this.props.Reportdata?.locationLabel || "All Locations";
		const groupName = this.props.Reportdata?.groupLabel || "All Groups";
		const startDate = this.props.params?.start_date || "—";
		const endDate = this.props.params?.end_date || "—";
		const brandName = this.props.params?.brand_name || "—";
		const subGroupName = this.props.params?.subgroup_name || "—";

		const rows = allProducts.map((product, idx) => ({
			"S.NO": idx + 1,
			"Location": product.location,
			"Group": product.group,
			"Sub Group": product.subgroup_name,
			"Code": product.code,
			"Bag Name": product.bag_name,
			"Brand Name": product.brand_name,
			"Base Unit": product.baseunit,
			"Available Stock": product.available_stock,
			"Pending PO No": product.pending_po_no,
			"Total PO Qty": product.total_po_qty,
			"Received Qty": product.received_qty,
			"Pending Qty": product.pending_qty,
		}));

		const topHeader = [
			"SRI LALITHA ENTERPRISES INDUSTRIES PVT. LTD",
			"Valuthimmapuram Road, PEDDAPURAM - 533437, E.G. Dist. - AP",
			"Phone No.0884-2326661, 62, Mobile No.9494127893",
			"",
			"PRODUCT STOCK REPORT",
			`From: ${startDate}  To: ${endDate}  Location: ${locationName}  Group: ${groupName}  Brand: ${brandName}  Sub Group: ${subGroupName}`,
		];

		const fileType =
			"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

		const ws = XLSX.utils.book_new();
		XLSX.utils.sheet_add_aoa(ws, topHeader.map((h) => [h]));

		const headerWidth = rows.length > 0 ? Object.keys(rows[0]).length - 1 : 6;
		ws["!merges"] = topHeader.map((_, i) => ({
			s: { r: i, c: 0 },
			e: { r: i, c: headerWidth },
		}));

		XLSX.utils.sheet_add_json(ws, rows, {
			origin: "A" + (topHeader.length + 1),
			skipHeader: false,
		});

		const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
		const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
		const blob = new Blob([excelBuffer], { type: fileType });
		FileSaver.saveAs(blob, "PRODUCT_STOCK_REPORT.xlsx");
	}

	// Group flat product list by group → subgroup, preserving global serial number
	groupProducts(products, pageStart) {
		const groups = [];
		let globalIdx = pageStart;

		products.forEach((product) => {
			const groupName = product.group || "Ungrouped";
			const subGroupName = product.subgroup_name || "";

			let grp = groups.find((g) => g.name === groupName);
			if (!grp) {
				grp = { name: groupName, subgroups: [] };
				groups.push(grp);
			}

			let sub = grp.subgroups.find((s) => s.name === subGroupName);
			if (!sub) {
				sub = { name: subGroupName, products: [] };
				grp.subgroups.push(sub);
			}

			sub.products.push({ ...product, _sno: ++globalIdx });
		});

		return groups;
	}

	render() {
		const { loading, productStockParams, productStockExportLoading } = this.props;
		const products = this.props.ProductStock_ReportData || [];
		const locationName = this.props.Reportdata?.locationLabel || "All Locations";
		const groupName = this.props.Reportdata?.groupLabel || "All Groups";
		const startDate = this.props.params?.start_date || "—";
		const endDate = this.props.params?.end_date || "—";
		const brandName = this.props.params?.brand_name || "—";
		const subGroupName = this.props.params?.subgroup_name || "—";

		const currentPage = productStockParams?.page || 1;
		const totalPages = productStockParams?.no_of_pages || 1;
		const totalCount = productStockParams?.count || 0;
		const pageSize = productStockParams?.page_size || 20;
		const pageStart = (currentPage - 1) * pageSize;

		const groupedData = this.groupProducts(products, pageStart);

		// total columns: S.NO, Location, Code, Bag Name, Brand Name, Sub Group, Picture, Base Unit,
		//                Available Stock, Pending Po No, Total PO Qty, Received Qty, Pending Qty = 13
		const totalCols = 13;

		return (
			<React.Fragment>
				<div className="page-content">
					<Container fluid>
						<Row>
							<Col md={12}>
								<Card>
									<CardHeader className="bg-transparent border-bottom no-print">
										<Link
											to="/ProductStockReports"
											className="action-icon text-primary mr-2">
											<i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
										</Link>
										<div className="float-right">
											{/* Custom Excel button — fetches all records */}
											<Button
												type="button"
												outline
												color="secondary"
												disabled={productStockExportLoading}
												onClick={() => this.handleExcelExport()}>
												{productStockExportLoading ? (
													<>
														<span
															className="spinner-border spinner-border-sm mr-1"
															role="status"
															aria-hidden="true"
														/>
														Exporting...
													</>
												) : (
													<>
														<i className="ri-file-excel-2-line"></i>
														<span className="d-none d-inline-block ml-1">
															Excel
														</span>
													</>
												)}
											</Button>
											<Button
												type="button"
												outline
												color="secondary"
												className="ml-2"
												onClick={() => window.print()}>
												<i className="mdi mdi-printer"></i>
												<span className="d-none d-inline-block ml-1">
													Print
												</span>
											</Button>
										</div>
									</CardHeader>
									<CardBody className="pt-2">
										{/* Print header */}
										<div className="text-center">
											<span className="display_none printme">
												<h5 className="card-title-18 pt-2">
													SRI LALITHA ENTERPRISES INDUSTRIES PVT. LTD
												</h5>
												<p className="card-title-14 pt-2 mb-0">
													Valuthimmapuram Road, PEDDAPURAM - 533437,
													E.G. Dist. - AP
												</p>
												<p className="card-title-14 pt-2">
													Phone No.0884-2326661, 62, Mobile No.9494127893
												</p>
												<hr />
											</span>
											<h5 className="card-title-16 pt-3">
												PRODUCT STOCK REPORT
											</h5>
											<p className="card-title-14 mb-2">
												<strong>From:</strong> {startDate}&nbsp;&nbsp;
												<strong>To:</strong> {endDate}&nbsp;&nbsp;
												<strong>Location:</strong> {locationName}&nbsp;&nbsp;
												<strong>Group:</strong> {groupName}&nbsp;&nbsp;
												<strong>Brand:</strong> {brandName}&nbsp;&nbsp;
												<strong>Sub Group:</strong> {subGroupName}
											</p>
										</div>

										{/* Loading spinner */}
										{loading ? (
											<div className="text-center py-5">
												<div
													className="spinner-border text-primary"
													role="status"
													style={{ width: "3rem", height: "3rem" }}>
													<span className="sr-only">Loading...</span>
												</div>
												<p className="mt-3 text-muted font-size-14">
													Loading report data, please wait...
												</p>
											</div>
										) : products.length === 0 ? (
											<div className="text-center py-4">
												<span className="font-size-18 text-danger">
													Data not available
												</span>
											</div>
										) : (
											<>
												{/* Table */}
												<div className="table-responsive m-0">
													<Table
														bordered
														hover
														className="mb-0 p-0 table-centered">
														<thead>
															<tr className="bg-light text-center">
																<th className="nowrap">S.NO</th>
																<th className="nowrap">Location</th>
																<th className="nowrap">Code</th>
																<th>Bag Name</th>
																<th>Brand Name</th>
																<th>Sub Group</th>
																<th className="nowrap">Picture</th>
																<th className="nowrap">Base Unit</th>
																<th className="nowrap">Available Stock</th>
																<th className="nowrap">Pending Po No</th>
																<th className="nowrap">Total PO Qty</th>
																<th className="nowrap">Received Qty</th>
																<th className="nowrap">Pending Qty</th>
															</tr>
														</thead>
														<tbody>
															{groupedData.map((grp) => (
																<React.Fragment key={grp.name}>
																	{/* Group heading */}
																	<tr>
																		<td
																			colSpan={totalCols}
																			className="text-center font-weight-bold font-size-14"
																			style={{
																				background: "#cfe2ff",
																				letterSpacing: "0.5px",
																			}}>
																			{grp.name}
																		</td>
																	</tr>
																	{grp.subgroups.map((sub) => (
																		<React.Fragment key={`${grp.name}-${sub.name}`}>
																			{/* Sub Group heading (only if name is non-empty) */}
																			{sub.name && (
																				<tr>
																					<td
																						colSpan={totalCols}
																						className="text-center font-weight-bold font-size-13"
																						style={{
																							background: "#e9ecef",
																							letterSpacing: "0.3px",
																						}}>
																						{sub.name}
																					</td>
																				</tr>
																			)}
																			{/* Product rows */}
																			{sub.products.map((product) => (
																				<tr
																					key={product.id}
																					className="text-center">
																					<td>{product._sno}</td>
																					<td className="text-left">
																						{product.location}
																					</td>
																					<td>{product.code}</td>
																					<td className="text-left">
																						{product.bag_name}
																					</td>
																					<td className="text-left">
																						{product.brand_name}
																					</td>
																					<td className="text-left">
																						{product.subgroup_name}
																					</td>
																					<td>
																						{product.image ? (
																							<img
																								src={product.image}
																								alt={product.bag_name}
																								style={{
																									width: "60px",
																									height: "60px",
																									objectFit: "contain",
																								}}
																							/>
																						) : (
																							<span className="text-muted">
																								—
																							</span>
																						)}
																					</td>
																					<td>{product.baseunit}</td>
																					<td>{product.available_stock}</td>
																					<td>
																						{product.pending_po_no || "—"}
																					</td>
																					<td>{product.total_po_qty}</td>
																					<td>{product.received_qty}</td>
																					<td>{product.pending_qty}</td>
																				</tr>
																			))}
																		</React.Fragment>
																	))}
																</React.Fragment>
															))}
														</tbody>
													</Table>
												</div>

												{/* Pagination */}
												<div className="d-flex justify-content-between align-items-center mt-3 no-print flex-wrap">
													<span className="text-muted font-size-13">
														Showing {pageStart + 1}–
														{Math.min(pageStart + pageSize, totalCount)} of{" "}
														{totalCount} products
													</span>
													<nav>
														<ul className="pagination pagination-sm mb-0">
															<li
																className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
																<button
																	className="page-link"
																	onClick={() => this.fetchPage(1)}
																	disabled={currentPage === 1}>
																	«
																</button>
															</li>
															<li
																className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
																<button
																	className="page-link"
																	onClick={() => this.fetchPage(currentPage - 1)}
																	disabled={currentPage === 1}>
																	‹
																</button>
															</li>
															{Array.from({ length: totalPages }, (_, i) => i + 1)
																.filter(
																	(p) =>
																		p === 1 ||
																		p === totalPages ||
																		Math.abs(p - currentPage) <= 2
																)
																.reduce((acc, p, i, arr) => {
																	if (i > 0 && p - arr[i - 1] > 1) acc.push("...");
																	acc.push(p);
																	return acc;
																}, [])
																.map((p, i) =>
																	p === "..." ? (
																		<li
																			key={`ellipsis-${i}`}
																			className="page-item disabled">
																			<span className="page-link">…</span>
																		</li>
																	) : (
																		<li
																			key={p}
																			className={`page-item ${currentPage === p ? "active" : ""}`}>
																			<button
																				className="page-link"
																				onClick={() => this.fetchPage(p)}>
																				{p}
																			</button>
																		</li>
																	)
																)}
															<li
																className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
																<button
																	className="page-link"
																	onClick={() => this.fetchPage(currentPage + 1)}
																	disabled={currentPage === totalPages}>
																	›
																</button>
															</li>
															<li
																className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
																<button
																	className="page-link"
																	onClick={() => this.fetchPage(totalPages)}
																	disabled={currentPage === totalPages}>
																	»
																</button>
															</li>
														</ul>
													</nav>
												</div>
											</>
										)}
									</CardBody>
								</Card>
							</Col>
						</Row>
					</Container>
				</div>
			</React.Fragment>
		);
	}
}

const mapStatetoProps = (state) => {
	const {
		params,
		Reportdata,
		ProductStock_ReportData,
		ProductStock_ExportData,
		productStockParams,
		productStockExportLoading,
		loading,
	} = state.reports;
	return {
		params,
		Reportdata,
		ProductStock_ReportData: ProductStock_ReportData || [],
		ProductStock_ExportData: ProductStock_ExportData || [],
		productStockParams: productStockParams || {
			page: 1,
			page_size: 20,
			no_of_pages: 0,
			count: 0,
		},
		productStockExportLoading: productStockExportLoading || false,
		loading: loading || false,
	};
};

export default connect(mapStatetoProps, {
	getProductStockReportList,
	getProductStockExportList,
})(ProductStockReportList);
